module.exports = __webpack_public_path__ + "static/img/coin.507028fb.png";